import React, { useState } from 'react'
import Sidebar from '../Sidebar/sidebar';
import Header from '../Header/header';
import { Outlet } from 'react-router-dom';
import "./layout.css";


const Layout = () => {
    const [isExpanded, setExpanded] = useState(false);
    const [isExpandedMob, setExpandedMob] = useState(false);
    return (
      <>
        <div className="layout__wrapper">
          <Header
            setExpanded={setExpanded}
            isExpanded={isExpanded}
            setExpandedMob={setExpandedMob}
            isExpandedMob={isExpandedMob}
          />
          <Sidebar
            isExpanded={isExpanded}
            isExpandedMob={isExpandedMob}
            setExpandedMob={setExpandedMob}
          />
          <div
            className={`outlet_wrapper 
                ${isExpanded ? "outlet_wrapper-small" : ""}
             `}
          >
            <Outlet />
          </div>
        </div>
      </>
    );
}

export default Layout
